// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HxWlR","clinicsSelect":"styles_clinicsSelect__1_Nz5"};